import { marked } from 'marked';
import './MarkdownRenderer.css';

// Open all rendered links in a new tab with safe rel attrs.
// rel="noopener noreferrer" prevents the opened page from accessing
// window.opener and avoids leaking referrer headers.
marked.use({
  renderer: {
    link({ href, title, tokens }) {
      const text = this.parser.parseInline(tokens);
      const titleAttr = title ? ` title="${title}"` : '';
      return `<a href="${href}"${titleAttr} target="_blank" rel="noopener noreferrer">${text}</a>`;
    },
  },
});

marked.setOptions({
  breaks: true, // Convert line breaks to <br>
  gfm: true,    // Enable GitHub Flavored Markdown
});

/**
 * Component to render Markdown text as HTML with proper styling
 */
function MarkdownRenderer({ content, className = '' }) {
  if (!content) return null;

  const htmlContent = marked(content);

  return (
    <div
      className={`markdown-content ${className}`}
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  );
}

export default MarkdownRenderer;
